import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { UserFields } from './user_components/UserFields';

import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';

import { getUserById } from '../../services/requests/GraphRequests';

import { ROLE } from '../../constants';

export default function EditUser(props) {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState({});

    useEffect(() => {
        getUserById(location.state.id).then(data => {
            setUser(data.data.getUser);
            setLoading(false);
        });
    }, [location]);

    if (loading) {
        return (
            <Container align='center' sx={{ mt: 10 }}>
                <CircularProgress />
            </Container>
        );
    }

    if (!user || props.role !== ROLE.director) return null;

    return (
        <UserFields
            pageTitle='edit_user'
            userInfo={user}
            cashRegistersList={props.organization.cashRegisters}
        />
    );
}
